import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Preference, PREFERENCE_LABELS, RosterRef } from '../../../invitations/models/invitation.model';
import { Composition, compositionOf } from '../../services/report-pool';
import { ReportMockService } from '../../services/report-mock.service';
import { REPORT_TYPE_ICON, REPORT_TYPE_LABELS, ReportType, TEAM_MEMBER_REPORT_CAP } from '../../models/report.model';

@Component({
  selector: 'app-report-step-review',
  templateUrl: './step-review.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class ReportStepReviewComponent implements OnInit {
  @Input() form!: FormGroup;
  @Input() orgs: RosterRef[] = [];

  composition!: Composition;

  readonly preferences: Preference[] = ['cl', 'id', 'dv', 'im'];
  readonly prefLabels = PREFERENCE_LABELS;
  readonly typeLabels = REPORT_TYPE_LABELS;
  readonly cap = TEAM_MEMBER_REPORT_CAP;

  constructor(private svc: ReportMockService) {}

  /**
   * Recomputed here rather than passed from Step 2: the review must describe what will actually be
   * saved, and reading it back off the form is the only way to be sure the two agree.
   */
  ngOnInit(): void {
    this.svc.pool(this.form.value.sourceOrgIds as string[]).subscribe(rows => {
      this.composition = compositionOf(rows, this.form.value.participantIds as string[]);
    });
  }

  get ownerName(): string {
    return this.orgs.find(o => o.id === this.form.value.ownerOrgId)?.name ?? '—';
  }
  get typeLabel(): string { return this.typeLabels[this.form.value.type as ReportType]; }
  get typeIcon(): string { return REPORT_TYPE_ICON[this.form.value.type as ReportType]; }

  get overCap(): boolean {
    return (this.form.value.type as ReportType) === 'team_member_report'
      && !!this.composition && this.composition.count > this.cap;
  }
  get missingLabels(): string { return this.composition.missing.map(p => this.prefLabels[p]).join(', '); }
}
